import ApprovedStatusActions from '../ActiveStatusActions/component';

export default ApprovedStatusActions;
